import { useEffect } from 'react';

/**
 * @param {React.MutableRefObject<HTMLElement | undefined>} modalRef
 * @param {boolean} enabled
 * @param {() => void} onPress
 *
 * @returns {void}
 */
export function useEscapePress(modalRef, enabled, onPress) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const modalElem = modalRef.current;
    if (!modalElem) {
      return;
    }

    /**
     * @param {KeyboardEvent} event
     */
    const handleEscapePress = (event) => {
      if (event.key === 'Escape') {
        onPress();
      }
    };

    modalElem.addEventListener('keydown', handleEscapePress);

    return () => {
      modalElem.removeEventListener('keydown', handleEscapePress);
    };
  }, [enabled, modalRef, onPress]);
}
